<div class="details-container">

  <div class="details-header" style="background: url(assets/images/sutton-sch.jpg);">
      
    <div class="details-banner">
        <h1>Sutton Grammar School</h1>
        <h2>11 Plus (11+) Exam Informatio</h2>
    </div>
</div>


<div class="details-publisher">
  <span><strong>Published by - SEHYOG Academy</strong></span>
</div>

<div class="details-content">

  <div class="details-section">

    <h3>Introduction</h3>

    <div class="spacer"></div>

    <p>Sutton Grammar School is a selective grammar school for boys in Sutton. Operational since 1899, it is regularly featured among the best state secondary schools in London. Sutton Grammar’s alumni list is long and impressive, including authors, inventors, politicians and historians. <br> <br>

 

      Maximising boys’ potential, the curriculum underpins the school’s comprehensive academic provision. Lessons for DT, business, science, philosophy, languages and many other options are delivered to suit pupils’ interests and expand their horizons, covering extensively broad areas of learning. <br> <br>
      
       
      
      The educational experience is further enhanced through a rich activities programme, including everything from photography and drama to Law Society and football. Excellence beyond the classroom is strongly encouraged, as is participation in competitions and workshops, resulting in a balanced and thriving cohort that boasts intellect in parallel with strong non-academic abilities. </p>



    <div class="spacer"></div>

    <h2>Sutton Grammar School 11 Plus (11+) Exam Information 2025</h2>

    <div class="spacer"></div>


    <p><strong>Address: </strong> Manor Lane, Sutton SM1 4AS</p>
    <p><strong>County:</strong> Berkshire</p>
    <p><strong>Admissions info:</strong> office&#64;suttongrammar.sutton.sch.uk, 020 8642 3821</p>
    <p><strong>School type:</strong>Boys’ Grammar</p>
    <p><strong>Number of pupils:</strong> 930 (approx.)</p>
    <p><strong>Number of places in Year 7</strong>135</p>
    <p><strong>Open Day date: </strong>September</p>
    <p><strong>11+ Exam date: </strong> September 2025</p>
    <p><strong>Pass mark:</strong>Aim for 75%+ (Stage 1) in our practice tests. See below for more details.</p>
    <p><strong>Exam type / Board:</strong>Part One: Multiple-Choice Maths and English (SET) / Part Two: Open Answer Maths and English</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Sutton Grammar School 11 Plus (11+) Admissions</h2>

    <div class="spacer"></div>

    <p>Sutton Grammar School is part of Sutton’s Coordinated Admissions Scheme and, as such, admission to the school is determined by pupil performance in the Selective Eligibility Test (SET), similar to the standard 11 Plus exam. <br> <br>

 

      Competition for the 150 places available in Year 7 is very high, so the school encourages prospective students and their parents to attend one of their open events, which usually take place in September. At these events, you will have the opportunity to learn more about the admissions process and tour the school, as well as speak to staff. <br> <br>
      
       
      
      In the likely event of Sutton Grammar School being oversubscribed in Year 7, the school applies these policies, in this priority order:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p>Part one: CEM Select</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Part two: English comprehension</p></div>

    <p>Your child’s results in the online CEM Select assessment will be combined, standardised and placed in rank order, on the basis of which his comprehension skills will then be assessed. Results from both exams will be combined and will determine his overall rank order.</p>

    <p>Please note that the school will assess applicants only if there are places available. If there are more applications than there are places available, Reading grammar will apply their oversubscription criteria, based on which priority will be given to:</p>

    <p>1. Looked after, or previously looked after boys <br>
      2. 75 places by rank order of the scores in the selection tests where the home address of the boy is in one of the postcodes (SM1-7, KT4, KT17, CR0 4–, CR4) <br>
      3. 60 places (plus any remaining places in criterion 2 if the number of qualified boys in criterion 2 is less than the 75 on offer) by rank order of the scores in the selection tests from any home address <br>
      4. The proximity of the boy’s home address from the school (where scores are equal)</p>

      <p>Sutton Grammar School adheres to a strict admission policy in Year 7, so parents are advised to read it before applying for a place.</p>


    <div class="spacer"></div>

    <h2>How to Apply for 11 Plus (11+) Entry to Sutton Grammar School</h2>

    <div class="spacer"></div>

    <p>Parents who wish to register their son to sit the SET (part one) must complete a Supplementary Form, which can be found on the school’s website when registration is open. <br> <br>

 

      Sutton Grammar School is part of the Pan-London Co-ordinated Admissions Scheme. To apply for a place at the school, parents must complete the Common Application Form (CAF) issued by their Local Authority. Those who live in London, or Surrey, can complete the CAF online. <br> <br>
      
       
      
      If students are successful in the SET, they will be invited to sit Sutton Grammar’s Second Stage Entrance Examination. Should they pass this test, parents must include Sutton Grammar on the CAF for pupils to be eligible for consideration for a Year 7 place.</p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Sutton Grammar School 11 Plus (11+) Exam Format</h2>

      <p>Sutton Grammar School’s 11 Plus tests have two stages:</p>


    <div><img src="assets/images/check-list.png" alt=""> <p> <strong>Stage 1:</strong> Maths and English, both multiple-choice and each last approximately 45 minutes.</p></div>

    <p>This SET is run in conjunction with other local schools in Sutton. The result of the SET determines whether or not a boy is eligible for the second stage test.</p>

    <div><img src="assets/images/check-list.png" alt=""> <p>Non-Verbal Reasoning</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p> <strong>Stage 2:</strong> Maths and English. Neither of these is multiple-choice. Maths consists of standard format questions. The English paper is a Writing task, which requires a response to some form of prompt.</p></div>


    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>How to Prepare for the Sutton Grammar School 11 Plus (11+) Exam?</h2>

    <p>One of the best ways to prepare for a competitive entrance exam is to use our practice papers. Getting to know the types of questions and the format of the actual exam will help boost your child’s confidence. <br> <br>

 

      Aside from becoming familiarised with the exam format, our practice tests will ensure that your child responds to the questions in an efficient and effective manner. <br> <br>
      
       
      
      They also provide an excellent opportunity for your child to practise working under time pressure. Whilst doing the tests under timed conditions, children can get used to answering questions quickly, with a close attention to detail. <br> <br>
      
       
      
      Our 11+ resources are thoroughly researched and up to date. They are designed to reflect the demands of a competitive grammar school entrance exam and are successfully used by hundreds of thousands of students every year.</p>



    <div class="spacer"></div>

    <h2>Sutton Grammar School 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

    <p>The 11+ entrance exam at Queen Elizabeth’s School, Barnet, consists of two multiple-choice test papers in:</p>

    <p>There is no formal pass mark for the Sutton Grammar School tests. Instead, entry is relative to the performance of the cohort of applicants. Hence, if there are stronger candidates applying in a particular year, the pass mark will be higher. <br> <br>

 

      Pupils who are able to score 75%+ consistently in our 11+ Stage 1 practice tests should be on track to pass the Sutton Grammar School Stage 1 exam. <br> <br>
      
       
      
      Whilst there are no guarantees, this has historically been a fairly strong indicator that your child should do well in the Sutton Grammar School entrance exams. Please click here to learn more.
      
       </p>

    <div class="spacer"></div>


  </div>

</div>

</div>